import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/card'
import { Button } from '@/components/ui/common/Button'
import { cn } from '@/utils/common'

interface StartCardProps {
  title: string
  description?: string
  descriptionHTML?: React.ReactNode
  subDescription?: string
  onStart: () => void
  className?: string
}

export default function StartCard({
  title,
  description,
  descriptionHTML,
  subDescription,
  onStart,
  className
}: StartCardProps) {
  return (
    <Card
      className={cn(
        'mx-auto  flex min-h-[40vh] w-full lg:min-w-xl flex-col items-center justify-center text-center',
        className
      )}
    >
      <CardHeader>
        <CardTitle className="text-2xl">{title}</CardTitle>
      </CardHeader>

      <CardContent className="space-y-6">
        {description && <p>{description}</p>}
        {descriptionHTML && descriptionHTML}
        {subDescription && <p className="text-sm text-gray-400">{subDescription}</p>}
      </CardContent>

      <CardFooter className="mt-4">
        <Button className="bg-[#2bcaca] hover:bg-[#2b9999]" onClick={onStart}>
          Rozpocznij zadanie
        </Button>
      </CardFooter>
    </Card>
  )
}
